var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2H10.9766V9H6V20H18V11.07H20V20C20 21.1 19.11 22 18.01 22H6C4.9 22 4 21.1 4 20V8L10 2ZM13 4V2H20V9H18V5.41L14.172 9.73344C13.7412 10.2199 12.9923 10.2506 12.5232 9.80096C12.0632 9.36008 12.0519 8.62844 12.4979 8.17351L16.59 4H13Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportGrid);
export default __webpack_public_path__ + "static/media/export-grid.db9c81d443905bf467a105b1f6c91857.svg";
export { ForwardRef as ReactComponent };